<template>
  <div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vx-card v-if="!isOnCreate" v-can="'view-other-orders'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Submitted', 'Accepted', 'Complete', 'Received', 'Returned']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Payment Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['payment-status']"
                         :options="['GRNI', 'Pre Invoice', 'Paid']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date From</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['from']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['from']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Date To</label>
              <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['to']"
                          placeholder="Choose Date"
              />
              <flat-pickr
                class="w-full"
                :config="{ dateFormat: 'd/m/Y'}"
                v-model="filters['to']"
                placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/3 sm:w-1/2 w-full mb-5">
              <label class="text-sm opacity-100 text-bold">Orderer Name</label>
              <v-select name="timescale_type" :closeOnSelect="true" :clearable="true" v-model="filters['ordered-by']"
                  :options="filtered_staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'" :reduce="option => option.value" label="name" multiple
                   />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card v-if="!is_on_create" title="" v-can="'view-other-orders'" >
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'other-order-sheet'" :filters="filters"/>
              <vs-button v-can="'create-edit-other-orders'" @click="onClickCreateNewOrder" class="mr-4" color="primary" type="filled">Create new order</vs-button>
            </div>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="supplier-orders-table" :max-items="(meta.per_page) ? meta.per_page : 10" :data="orders" @sort="handleSort"   :sst="true" stripe class="table-auto table-dark-inverted vs-con-loading__container">

              <template slot="thead">
                <vs-th width="15%" sort-key="created_at">DATE/TIME</vs-th>
                <vs-th width="10%">ORDER CODE</vs-th>
                <vs-th width="10%">ORDERER NAME</vs-th>
                <vs-th width="20%" v-if="!supplier_id" >SUPPLIER</vs-th>
                <vs-th width="10%">PAYMENT STATUS</vs-th>
                <vs-th width="5%" v-if="$can('create-edit-sage-purchase-order')">SAGE ID</vs-th>
                <vs-th width="20%" >STATUS</vs-th>
                <vs-th width="10%" class="">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickDetailsView(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].created_at">
                    {{__dateTimeFormatter(data[indextr].created_at)}}
                  </vs-td>

                  <vs-td :data="data[indextr].order_code">
                    {{ data[indextr].order_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].created_by_staff">
                    {{ data[indextr].created_by_staff}}
                  </vs-td>

                  <vs-td v-if="!supplier_id" :data="data[indextr].supplier.company_name">
                    {{ data[indextr].supplier.company_name}}
                  </vs-td>

                  <vs-td>
                    {{ paymentStatusGenerator(data[indextr].order_items) }}
                  </vs-td>

                  <vs-td v-if="$can('create-edit-sage-purchase-order')">
                    <span v-if="data[indextr].sage_purchase_order_id || data[indextr].sage_order_number">
                      {{ data[indextr].sage_order_number ? data[indextr].sage_order_number : data[indextr].sage_purchase_order_id}}
                    </span>
                    <span class="text-danger cursor-pointer" v-else>
                      <vx-tooltip class="mr-2" text="Sync order to sage" position="left">
                        <vs-button @click.stop="onClickSageSyncOrder(data[indextr])"
                                 size="small" color="danger" type="filled" icon-pack="feather" icon="icon-refresh-cw"/>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td :data="data[indextr].status.name">
                    <vs-chip style="border-radius: 0" transparent :color="projectBriefColorFactory(tr.status.name)">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip class="mr-2" text="View Order" position="left">
                        <vs-button @click.stop="onClickDetailsView(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'create-edit-other-orders'"  class="mr-2" text="Update Order" position="left">
                        <vs-button @click.stop="onClickServicesOrdersUpdate(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>

                    </div>
                  </vs-td>

<!--                  <template class="expand-user" slot="expand">-->
<!--                    <div class="w-full con-expand-users p-8">-->
<!--                      <div class="flex items-center justify-between con-btns-user">-->
<!--                        <div class="flex items-center justify-start con-userx">-->
<!--                        </div>-->
<!--                        <div class="flex mb-4">-->
<!--                          <vs-button v-if="['Submitted'].includes(tr.status.name)" @click="onClickStatusChangeConfirm(tr.id, 'accept')" type="border" size="small" icon-pack="feather" icon="icon-log-in" color="warning" class="mr-2">Accept Order</vs-button>-->
<!--                          <vs-button v-if="['Accepted'].includes(tr.status.name)" @click="onClickStatusChangeConfirm(tr.id, 'receive')"  type="border" size="small" icon-pack="feather" icon="icon-box" color="success" class="mr-2">Receive Order</vs-button>-->
<!--                          <vs-button v-if="['Received'].includes(tr.status.name)" @click="onClickStatusChangeConfirm(tr.id, 'return')" type="border" size="small" icon-pack="feather" icon="icon-x" color="danger" class="mr-2">Return Order</vs-button>-->
<!--                          <vs-button v-if="['Received'].includes(tr.status.name)" @click="onClickStatusChangeConfirm(tr.id, 'complete')" type="border" size="small" icon-pack="feather" icon="icon-check" color="primary" class="mr-2">Complete Order</vs-button>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                      <div class="vx-row mb-8">-->
<!--                        <div class="w-full vx-col md:w-1/3 md:mb-0">-->
<!--                          <h4 class="my-2">Address</h4>-->
<!--                          {{tr.line1 ? `${tr.line1}, ` : ''}}-->
<!--                          {{tr.line2 ? tr.line2+', ' : ''}}-->
<!--                          {{tr.line3 ? tr.line3+', ' : ''}}-->
<!--                          {{tr.town_state ? tr.town_state+', ' : ''}}-->
<!--                          {{tr.post_code ? tr.post_code+', ' : ''}}-->
<!--                          {{tr.country ? tr.country+', ' : ''}}-->
<!--                        </div>-->
<!--                        <div class="w-full vx-col md:w-1/3 md:mb-0">-->
<!--                          <h4 class="my-2">Special delivery instructions</h4>-->
<!--                          {{tr.delivery_instruction ? tr.delivery_instruction : 'N/A'}}-->
<!--                        </div>-->
<!--                        <div class="w-full vx-col md:w-1/3 md:mb-0">-->
<!--                          <h4 class="my-2">Note</h4>-->
<!--                          {{tr.note ? tr.note : 'N/A'}}-->
<!--                        </div>-->
<!--                      </div>-->

<!--                      <div class="vx-row mb-4">-->
<!--                        <div class="w-full vx-col md:w-2/3 md:mb-0">-->
<!--                          <h4 class="my-2">Order service items</h4>-->
<!--                          <vs-table :data="data[indextr].order_items">-->

<!--                            <template slot="thead">-->
<!--                              <vs-th>Service</vs-th>-->
<!--                              <vs-th>Unit price Excl vat/tax in GBP</vs-th>-->
<!--                              <vs-th>VAT in GBP</vs-th>-->
<!--                              <vs-th>Quantity</vs-th>-->
<!--                            </template>-->

<!--                            <template slot-scope="{data}">-->
<!--                              <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">-->

<!--                                <vs-td :data="tr_item.other_supplier_service_name">-->
<!--                                  {{ tr_item.other_supplier_service_name }}-->
<!--                                </vs-td>-->

<!--                                <vs-td :data="tr_item.unit_price">-->
<!--                                  {{ tr_item.unit_price }}-->
<!--                                </vs-td>-->

<!--                                <vs-td :data="tr_item.vat">-->
<!--                                  {{ tr_item.vat || 'N/A'}}-->
<!--                                </vs-td>-->

<!--                                <vs-td :data="tr_item.quantity">-->
<!--                                  {{ tr_item.quantity }}-->
<!--                                </vs-td>-->

<!--                              </vs-tr>-->
<!--                            </template>-->

<!--                          </vs-table>-->
<!--                        </div>-->
<!--                        <div class="w-full vx-col md:w-1/3 md:mb-0">-->
<!--                          <h4 class="my-2">Additional cost</h4>-->
<!--                          <vs-table :data="data[indextr].additional_cost">-->

<!--                            <template slot="thead">-->
<!--                              <vs-th width="50%">Name</vs-th>-->
<!--                              <vs-th width="50%">Amount Excl vat/tax in GBP</vs-th>-->
<!--                              <vs-th width="50%">VAT in GBP</vs-th>-->
<!--                            </template>-->

<!--                            <template slot-scope="{data}">-->
<!--                              <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">-->

<!--                                <vs-td :data="tr_item.name">-->
<!--                                  {{ tr_item.name }}-->
<!--                                </vs-td>-->

<!--                                <vs-td :data="tr_item.amount">-->
<!--                                  {{ tr_item.amount }}-->
<!--                                </vs-td>-->

<!--                                <vs-td :data="tr_item.vat">-->
<!--                                  {{ tr_item.vat || 'N/A'}}-->
<!--                                </vs-td>-->

<!--                              </vs-tr>-->
<!--                            </template>-->

<!--                          </vs-table>-->
<!--                        </div>-->
<!--                      </div>-->

<!--                    </div>-->
<!--                  </template>-->

                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination 
              v-on:changeMaxItems="changePage"
              :size-array="meta.total? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page" 
                class="p-5"></vs-pagination>

          </div>
        </vx-card>
        <other-supplier-cart-list v-on:back="refreshData($event)" v-if="is_on_create"/>
      </div>
    </div>
    <update-other-supplier-order-pop-up ref="UpdateOtherSupplierOrderPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier')
  const SageRepository = RepositoryFactory.get('sage')
  import UpdateOtherSupplierOrderPopUp from '@/components/popups/other-suppliers/orders/UpdateOtherSupplierOrderPopUp'
  import OtherSupplierCartList from './OtherSupplierCartList'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import { defaultPagination, perPageList } from '@/constants/config';
  import { mapActions, mapGetters } from 'vuex';
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'AllOrdersList',
    data () {
      return {
        supplier_id: '',
        orders: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        is_on_create: false
      }
    },
    components: {
      'v-select': vSelect,
      UpdateOtherSupplierOrderPopUp,
      OtherSupplierCartList,
      flatPickr
    },
    computed: {
    ...mapGetters(['filtered_staffs'])
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    async mounted () {
      this.supplier_id = this.$route.params.id ? this.$route.params.id : null
      this.setFilterId('other-orders-list-filters',['search', 'from', 'to', 'ordered-by', 'payment-status', 'status'])
      await this.fetchFilteredStaffs()
    },
    methods: {
      ...mapActions(['fetchFilteredStaffs']),
      async refreshData () {
        this.is_on_create = false
        await this.loadOrders()
      },

      async loadOrders() {
        await this.$vs.loading()
        try {
          let data = {}
          if(this.supplier_id) {
            data= (await OtherSupplierRepository.getListOfServicesOrders(this.supplier_id, this.page, this.filterQuery, this.perPage, this.sort)).data
          } else {
            data= (await OtherSupplierRepository.getListOfAllServicesOrders(this.page, this.filterQuery, this.perPage, this.sort)).data
          }
          this.orders =  data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickSageSyncOrder(data){
        let payload = {
          order_id: data.id,
          order_type: 'other',
          supplier_id : data.other_supplier_sage_id,
          document_no: data.order_code,
          supplier_document_no: data.order_code,
          lines: data.order_items.map((n) => {
            return {
              line_type:1,
              use_description:true,
              description: n.description || n.other_supplier_service_name,
              line_quantity: n.quantity+ '',
              allocated_quantity: n.quantity+ '',
              unit_buying_price: n.unit_price + ''
            }
          })
        }
        if ( data.other_supplier_sage_id) {
          this.$vs.loading()
          try {
            await SageRepository.createRmOrder({orders: [payload]})
            await this.refreshData()
          } catch (error) {
            this.convertAndNotifyError(error)
          }
          this.$vs.loading.close()
        }
        else {
          this.$vs.dialog({
            color: 'danger',
            title: `Warning`,
            text: 'This Supplier is not synchronised on Sage. You must do that before you can attempt to synchronise any RM order.',
            acceptText: 'Close'
          })
        }

      },

      async onClickServicesOrdersUpdate (id) {
        await this.$refs.UpdateOtherSupplierOrderPopUp.openPopup(id, this.supplier_id)
      },
      onClickCreateNewOrder() {
        this.is_on_create = true
      },
      onClickDetailsView(id){
        this.$router.push({path: `/pages/other-supplier-service/orders/${id}`})
      },

      filterQueryUpdate (){
        this.loadOrders()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadOrders()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadOrders()
        }
      },
      projectBriefColorFactory(status) {
        switch (status) {
          case 'Submitted':
            return 'dark';
          case 'Accepted':
            return 'warning';
          case 'Received':
            return 'success';
          case 'Returned':
            return '#f05945';
          case 'Completed':
            return '#206a5d';
        }
      },
      onClickStatusChangeConfirm(id, status) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'primary',
          title: 'Confirm',
          text: 'Are you sure you want to make this change?',
          accept: this.onChangeSampleOrderStatus,
          parameters: [id, status]
        })
      },
      async onChangeSampleOrderStatus(params){
        await this.$vs.loading({
          container: '#supplier-orders-table',
          scale: 0.45
        })
        try {
          await OtherSupplierRepository.statusChangeSupplierServicesOrder(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.loadOrders()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#supplier-orders-table > .con-vs-loading')
      },
      paymentStatusGenerator(items) {
        const firstItemStatus = items[0].payment_status;
        const allItemsHaveSameStatus = items.every(item => item.payment_status === firstItemStatus);
        return (items.length === 1 ) ? firstItemStatus : (allItemsHaveSameStatus ? firstItemStatus : 'Multiple Items');
      }

    },
    watch : {
      page(){
        this.loadOrders()
      },
      perPage() {
        this.loadOrders()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  table td {
    vertical-align: top;
    min-width: 140px;
    padding-bottom: .8rem;
    word-break: break-all;
    }

</style>
